import API from 'api';
import { axiosAPI, withLoading } from 'utils';
import _ from "lodash";
import { showError } from "actions/statusActions";

export const fetchActivityGroups = params => dispatch =>
  withLoading(dispatch, () =>
    axiosAPI
      .get('api/flink-make/activity-groups', { params })
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        return (err && err.response && err.response.data) ? err.response.data : { success: false, message: err && err.message ? err.message : 'Request failed' };
      })
  );

export const getGroupElementsById = id => dispatch =>
  withLoading(dispatch, () => API.activityGroups.getGroupElementsById(id));

export const checkIfGroupsCanBeAdded = (...args) => dispatch =>
  withLoading(dispatch, () =>
    API.activityGroups.checkIfGroupsCanBeAdded(...args)
  );

export const addActivityGroup = data => dispatch =>
  withLoading(dispatch, () =>
    axiosAPI
      .post('api/flink-make/activity-groups', data)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.error(err);
        return (err && err.response && err.response.data) ? err.response.data : { success: false, message: err && err.message ? err.message : 'Request failed' };
      })
  );

export const editActivityGroup = data => dispatch =>
  withLoading(dispatch, () =>
    axiosAPI
      .put('api/flink-make/activity-groups', data)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.error(err);
        return (err && err.response && err.response.data) ? err.response.data : { success: false, message: err && err.message ? err.message : 'Request failed' };
      })
  );

export const deleteActivityGroup = id => dispatch =>
  withLoading(dispatch, () =>
    axiosAPI
      .delete(`api/flink-make/activity-groups/${id}`)
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        return (err && err.response && err.response.data) ? err.response.data : { success: false, message: err && err.message ? err.message : 'Request failed' };
      })
  );

export const deleteWordGroupFiles = files => dispatch =>
  withLoading(dispatch, () => API.storage.deleteFiles(files));

export const moveToWordAgList = wordAgIds => dispatch =>
  withLoading(dispatch, async () =>
    axiosAPI
      .post('/api/flink-make/activity-groups/move-to-word-ag-list', { wordAgIds })
      .then(res => {
        if (!res.data.success) {
          return console.log(res.data);
        }

        return true;
      })
      .catch(err => {
        console.log(err);
        return false;
      })
  );

export const removeFromWordAgList = wordAgIds => dispatch =>
  withLoading(dispatch, async () =>
    axiosAPI
      .post('/api/flink-make/activity-groups/remove-from-word-ag-list', { wordAgIds })
      .then(res => {
        if (!res.data.success) {
          return console.log(res.data);
        }

        return true;
      })
      .catch(err => {
        console.log(err);
        return false;
      })
  );

export const copyWordlistFiles = (groupId, data) => dispatch =>
  withLoading(dispatch, async () => {
    const result = {};

    return axiosAPI
      .post(`/api/activity-groups/copy-wordlist-files/${groupId}`, data)
      .then(res => {
        if (!res.data) throw new Error("Error copy files");

        result.group = res.data;
        return result;
      })
      .catch(err => {
        console.log(err);
        result.error = err;
        return result;
      });
  });

export const checkGroup = (groups, userId = null) => dispatch =>
  withLoading(dispatch, () =>
    axiosAPI
      .post('api/flink-make/activity-groups/check-group', { groups, userId })
      .then(res => {
        return res.data.groups;
      })
      .catch(err => {
        console.error(err);
        return (err && err.response && err.response.data) ? err.response.data : { success: false, message: err && err.message ? err.message : 'Request failed' };
      })
  );

export const removeElementsFromWordAg = (elementsIds, locale = 'en') => dispatch =>
  withLoading(dispatch, async () =>
    axiosAPI
      .post('/api/flink-make/activity-groups/remove-elements-from-word-ag', { elementsIds, locale })
      .then(res => {
        if (!res.data.success) {
          return false;
        }
        console.log('removeElementsFromWordAg res', res);
        return res.data.result.length;
      })
      .catch(err => {
        console.log('removeElementsFromWordAg err',err);
        return false;
      })
  );

export const checkGroupWords = (words, locale) => (dispatch, getState) =>
  withLoading(dispatch, async () => {
    let passedWords = [];
    const allWordsAssets = {};
    let missedWords = []
    
    return axiosAPI
      .post('api/flink-make/activity-groups/check-group-words', { words, locale })
      .then(res => {
        const { words } = res.data;
        missedWords = res.data.missedWords;
        
        //Check if words have assets
        passedWords = words.map(item => item[0]).filter(item => item);
        const allAssets = [];
        const {
          common: { locales }
        } = getState();
        const activityLocaleObj = _.find(locales, { code: locale });

        passedWords.forEach(word => {
          let wordAudio = "";
          let definitionAudio = "";
          
          // Get word audio asset
          if (word?.wordAudio) {
            const firstLetter = word.word[0].toUpperCase();
            wordAudio = `Audio/Generic/WordsDB/${activityLocaleObj.name}/Words/${firstLetter}/${word.wordAudio}`;
            allAssets.push(
              `Audio/Generic/WordsDB/${activityLocaleObj.name}/Words/${firstLetter}/${word.wordAudio}`
            );
          }

          // Get definition audio asset
          if (word?.definitionAudio) {
            const firstLetter = word.definitionAudio[0].toUpperCase();
            definitionAudio = `Audio/Generic/WordsDB/${activityLocaleObj.name}/Definitions/${firstLetter}/${
              word.definitionAudio}`;
            allAssets.push(
              `Audio/Generic/WordsDB/${activityLocaleObj.name}/Definitions/${firstLetter}/${word.definitionAudio}`
            );
          }

          allWordsAssets[word.relatedWord] = {wordAudio,definitionAudio};
        });
        
        // Send assets for check
        return axiosAPI.post(
          "api/flink-make/wordlists/check-assets",
          allAssets
        );
      })
      .then(response => {
        const missedAssets = response.data
          .filter(res => !res.success)
          .map(res => res.key);

        return Promise.resolve({ words: passedWords, missedAssets, allWordsAssets, missedWords });
      })
      .catch(err => {
        console.log(err);

        if (err.custom) {
          dispatch(showError({ message: err.message }));
        }

        return Promise.resolve(null);
      });
  });
  
export const copyOtherLangWordsFiles = (activeGroup, allWordsAssets, locale) => (dispatch) =>
  withLoading(dispatch, async () => {
    const result = {};
    const data = {activeGroup, allWordsAssets, locale};

    return axiosAPI
      .post(`/api/flink-make/activity-groups/copy-other-lang-words-files`, data)
      .then(res => {
        if (!res.data) throw new Error("Error copy files");

        result.group = res.data;
        return result;
      })
      .catch(err => {
        console.log(err);
        result.error = err;
        return result;
      });
  });
